import { Fragment, useMemo } from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { gql } from "__generated__/gql";
import { AddressComponentFieldsFragment } from "__generated__/gql/graphql";

export const addressFieldsFragment = gql(/* GraphQL */ `
  fragment AddressComponentFields on Address {
    line1
    line2
    city
    state
    zip
  }
`);

export type AddressProps = BoxProps & {
  address: Partial<AddressComponentFieldsFragment> | null | undefined;
  isMultiLine?: boolean;
};

function Address({ address, isMultiLine = true, ...rest }: AddressProps) {
  const lines = useMemo(() => {
    if (!address) return;

    const { line1, line2, city, state, zip } = address;

    const cszLine = [[city, state].filter((t) => t).join(", "), zip]
      .filter((t) => t)
      .join(isMultiLine ? " " : ", ")
      .trim();

    return [line1, line2, cszLine].filter((t) => t) as string[];
  }, [address, isMultiLine]);

  if (!lines) return null;

  if (!isMultiLine) {
    return (
      <Box as="span" {...rest}>
        {lines.join(", ")}
      </Box>
    );
  }

  const numLines = lines.length;

  return (
    <Box {...rest}>
      {lines.map((line, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={`${line}-${i}`}>
          {line}
          {i < numLines - 1 && <br />}
        </Fragment>
      ))}
    </Box>
  );
}
export default Address;
